module.exports = __webpack_public_path__ + "static/media/1POLICY34.53d34b4c.jpg";